import { forwardRef, useState } from 'react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Text } from '@/modules/ui';

import { Fields } from '../../../../constants';
import type { Secret } from '../../../../types';
import { CopySecretValue, type CopySecretValueProps } from '../CopySecretValue';
import { TOTPCountdown } from '../TOTPCountdown';
import * as felaRules from './CopySecretTOTP.rules';

export interface CopySecretTOTPProps {
    id: Secret['id'];
    disabled: boolean;
}

export const CopySecretTOTP = forwardRef<HTMLDivElement, CopySecretTOTPProps>(({ id, disabled }, TOTPFieldRef) => {
    const { css } = useFela();

    const [copied, setCopied] = useState(false);

    const handleCopy: CopySecretValueProps['onCopy'] = ({ success }) => {
        setCopied(success);
    };

    return (
        <div className={css(felaRules.container)}>
            <Text color={!disabled ? 'foregroundsPrimary' : 'foregroundsTertiary'} customStyle={felaRules.cryptedCharacters}>
                <FormattedMessage id='crypted.totp' />
            </Text>
            <CopySecretValue id={id} property={Fields.TOTP} disabled={disabled} onCopy={handleCopy} />
            {!disabled && <TOTPCountdown id={id} copied={copied} ref={TOTPFieldRef} />}
        </div>
    );
});
